'use client'

import Link from 'next/link'
import { FadeIn } from '@/app/components/FadeIn'

export default function NotFound() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white px-6 text-center">
      <FadeIn y={20}>
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
      </FadeIn>

      <FadeIn delay={0.15} y={20}>
        <p className="mt-4 text-lg text-gray-600">
          Oops! The page you are looking for does not exist.
        </p>
      </FadeIn>

      <FadeIn delay={0.3} y={20}>
        <Link
          href="/"
          className="mt-8 rounded-xl bg-indigo-600 px-6 py-3 text-white font-medium shadow hover:bg-indigo-500 transition"
        >
          Back to Home
        </Link>
      </FadeIn>
    </main>
  )
}
